<template>
  <div v-if="salary !== null"
       class="resume-active-responses__item-salary">
    {{ salary }}
    <span>
      {{ currentCurrency }}<template v-if="salaryPerType">/</template>{{ salaryPerType }}
    </span>
    <sub>{{ $tResumePage('net') }}</sub>
  </div>
</template>

<script>
  import formatNumber from '@/helpers/formatNumber'

  export default {
    name: 'ResumeActiveResponsesItemSalary',
    props: {
      section: Object
    },
    computed: {
      salary() {
        const salary = this.section.salary_in_selected_currency
        return this.getSalary(salary)
      },

      salaryPerType() {
        const type = this.section.salary_type
        return type ? type.name : null
      },

      currentCurrency() {
        let currentCurrency = this.$store.state.currentCurrency
        if (currentCurrency.currency === 'ALL') {
          currentCurrency = this.section.currency
        }

        return currentCurrency && currentCurrency.symbol
      },
    },
    methods: {
      getSalary(salary) {
        if (Array.isArray(salary)) {
          if (isNaN(parseFloat(salary[0])) || isNaN(parseFloat(salary[1]))) {
            return null
          }

          return salary[0] === salary[1]
            ? formatNumber(salary[0])
            : `${formatNumber(salary[0])} - ${formatNumber(salary[1])}`
        }

        return isNaN(parseFloat(salary)) ? null : formatNumber(salary)
      }
    }
  }
</script>

<style lang="less">

</style>
